import styled from "styled-components";

export const FPFormControl = styled.form`
    width: 21.65em;
    min-height: auto;
    background: #FFFFFF;
    border-radius: 1.15em;
    align-self: start;
    padding: 2em 3.5em; 
`

